import { Button } from '@blueprintjs/core';
import { DuLieuHeThong, ThongKeBaoCao, BaoCaoThanhTra, TrangChu } from 'api';
import DataTable, { DataTableKetQua } from 'components/data-table';
import {
  DropDownChonLoaiKyThongKe,
  DropDownChonLoaiNamThongKe,
  DropDownChonLoaiQuyThongKe,
  DropDownChonLoaiThangThongKe,
  DropDownMulipleUse,
  DropDownChonDonViThongKe
} from 'components/tt-forms';
import { DatePicker, DropDownTreeMultipleSelect } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { API_URL } from 'constants/config';
import { downloadFile } from "constants/downloadFile";
import { downloadExcel } from 'constants/downloadExcel';
import { header } from 'constants/table';
import {
  ListItemKetQuaThucHienKetLuanThanhTraHanhChinh,
  ListItemThongKeThanhTraDatDai,
  ListItemThongKeThanhTraHanhChinh,
  ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh,
  ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh,
  ListItemThongKeThanhTraXayDungCoBan,
  ListItemThongKeThanhTraXayTaiChinhNganSach,
  ListItemKetQuaKiemTraChiTiet,
  ListItemKetQuaKiemTraTheoKeHoach,
  ListItemKetQuaKiemTraDotXuat,
  ListItemKetQuaTongHopKetQuaThanhTra
} from 'modules/thong-ke-bao-cao/datatable';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { ListItemThongKeThanhTraThamNhung } from './datatable';

class TongHopKetQua extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      search: false,
      searchLoading: true,
      data: [],
      dataSum: [],
      dataDonTrung: [],
      dataOptions: [],
      dataSelected: [],
      dataCapCoQuanThongKe: [],
      dataHinhThucThongKe: [],
      dataValueListFilter: {
        statisticType: 'YEAR',
        startDate: null,
        endDate: null,
        quarter: '',
        year: '',
        month: '',
        dsDonViId: ''
      },
      statisticType: 'YEAR',
      nguonDon: '',
      startDate: '',
      endDate: '',
      quarter: '',
      year: '',
      month: '',
      dsDonViId: '',
      dsDonViIdKQ: (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}).donViId,
      donViCon: false,
      donViChonDon: '',
      hinhThucThongKe: 'DON_VI',
      capCoQuanThongKe: '',
      init: true,
      isThanhTraTinh: false,
    }
  }

  componentDidMount() {
    this.getCheckLuaChonDonVi();
    this.getListData();
    this.getListDV();
    this.getCapCoQuanThongKe();
    this.getHinhThucThongKe();
  }

  getCheckLuaChonDonVi() {
    TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(res => {
      const { data } = res;
      this.setState({
        ...this.state,
        isThanhTraTinh: data,
      });
    })
  }


  getCapCoQuanThongKe() {
    ThongKeBaoCao.actions.getCapCoQuanThongKe.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataCapCoQuanThongKe: res.data._embedded.capCoQuanQuanLies
        })
      }
    })
  }

  getHinhThucThongKe() {
    ThongKeBaoCao.actions.getHinhThucThongKe.request().then(res => {
      if (res.data) {
        this.setState({
          dataHinhThucThongKe: res.data.map((item) => ({
            giaTri: item.value,
            ten: item.label
          }))
        })
      }
    })
  }

  getKiemTraChiTietDoanhNghiep(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getKiemTraChiTietDoanhNghiep.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getKiemTraTheoKeHoachDoanhNghiep(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getKiemTraTheoKeHoachDoanhNghiep.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.map((item, i) => ({ ...item, rootLevel: i < res.data.length - 1, })),
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getKiemTraDotXuat(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getKiemTraDotXuat.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.map((item, i) => ({ ...item, rootLevel: i < res.data.length - 1, })),
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getTongHopKetQuaThanhTra(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getTongHopKetQuaThanhTra.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.map((item, i) => ({ ...item, rootLevel: i < res.data.length - 1, })),
          tableLoading: false,
          search: false
        });
      }
    });
  }


  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  getListData(dataSearch) {

    let params = {
      statisticType: this.state.statisticType,
      hinhThucThongKe: this.state.hinhThucThongKe
    }

    if (dataSearch && dataSearch.quarter && dataSearch.statisticType == 'QUARTER') {
      params.quarter = dataSearch.quarter;
    }

    if (dataSearch && dataSearch.hinhThucThongKe) {
      params.hinhThucThongKe = dataSearch.hinhThucThongKe;
    }

    if (dataSearch && dataSearch.nguonDon) {
      params.nguonDon = dataSearch.nguonDon;
    }

    if (dataSearch && dataSearch.year && dataSearch.statisticType != 'OPTION') {
      params.year = dataSearch.year;
    }

    if (dataSearch && dataSearch.month && dataSearch.statisticType == 'MONTH') {
      params.month = dataSearch.month;
    }

    if (dataSearch && dataSearch.startDate && dataSearch.statisticType == 'OPTION') {
      params.startDate = moment(dataSearch.startDate).add(7, 'hours').toISOString();
    }

    if (dataSearch && dataSearch.endDate && dataSearch.statisticType == 'OPTION') {
      params.endDate = moment(dataSearch.endDate).add(7, 'hours').toISOString();
    }

    if (dataSearch && dataSearch.hinhThucThongKe == 'DON_VI' && dataSearch.dsDonViId) {
      params.dsDonViId = dataSearch.dsDonViId;
    }

    if (dataSearch && dataSearch.hinhThucThongKe == 'CAP_DON_VI' && dataSearch.capDonViId) {
      params.capDonViId = dataSearch.capDonViId;
    }

    if (params && params.hinhThucThongKe == 'DON_VI' && !params.dsDonViId && this.state.init == true) {
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      params.dsDonViId = String(userInfo.donViId);
    }

    if (this.props.type == 'TIEP_CONG_DAN') {
      this.getThongKeTiepCongDan(params);
    } else if (this.props.type == 'GIAI_QUYET_KHIEU_NAI') {
      this.getThongKeGQDKN(params);
    } else if (this.props.type == 'GIAI_QUYET_TO_CAO') {
      this.getThongKeGQDTC(params);
    } else if (this.props.type == 'XU_LY_DON') {
      this.getThongKeXuLyDon(params);
    } else if (this.props.type == 'THANH_TRA_HANH_CHINH') {
      this.getThongKeThanhTraHanhChinh(params);
    } else if (this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH') {
      this.getKetQuaThucHienKetLuanThanhTraHanhChinh(params);
    } else if (this.props.type == 'THANH_TRA_DAT_DAI') {
      this.getThongKeThanhTraDatDai(params);
    } else if (this.props.type == 'THANH_TRA_CHUYEN_NGANH') {
      this.getThongKeThanhTraChuyenNganh(params);
    } else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
      this.getThongKeThanhTraXayDungCoBan(params);
    } else if (this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH') {
      this.getKiemTraChuyenNganh(params);
    } else if (this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH') {
      this.getXuPhatKiemTraChuyenNganh(params);
    } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
      this.getThongKeThanhTraTaiChinhNganSach(params);
    } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
      this.getThongKePhatHienThamNhungQuaThanhTra(params);
    } else if (this.props.type == 'THANH_TRA_LAI') {
      this.getThongKeKetQuaThanhTraLai(params);
    } else if (this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP') {
      this.getKiemTraChiTietDoanhNghiep({ ...params, dsDonViId: this.state.dsDonViIdKQ });
    } else if (this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP') {
      this.getKiemTraTheoKeHoachDoanhNghiep({ ...params, dsDonViId: this.state.dsDonViIdKQ });
    } else if (this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP') {
      this.getKiemTraDotXuat({ ...params, dsDonViId: this.state.dsDonViIdKQ });
    } else if (this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA') {
      this.getTongHopKetQuaThanhTra({ ...params, dsDonViId: this.state.dsDonViIdKQ });
    }

  }

  getThongKeGQDKN(params) {
    this.setState({
      tableLoading: true
    });

    ThongKeBaoCao.actions.getThongKeGQDKN.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data.maSos,
          dataSum: res.data.tongCongs,
          pageData: res.data.page,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getThongKeThanhTraHanhChinh(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getTongHopKetQuaThanhTraHanhChinh.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    })
  }

  getKetQuaThucHienKetLuanThanhTraHanhChinh(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getKetQuaThucHienKetLuanThanhTraHanhChinh.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    })
  }

  getThongKeThanhTraDatDai(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getThongKeThanhTraDatDai.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getThongKeThanhTraChuyenNganh(params) {
    this.setState({
      tableLoading: true
    });

    ThongKeBaoCao.actions.getThongKeThanhTraChuyenNganh.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data.maSos,
          dataSum: res.data.tongCongs,
          pageData: res.data.page,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getThongKeThanhTraXayDungCoBan(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getThongKeThanhTraXayDungCoBan.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    })
  }

  getKiemTraChuyenNganh(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getKiemTraChuyenNganh.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    })
  }

  getXuPhatKiemTraChuyenNganh(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getXuPhatKiemTraChuyenNganh.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    })
  }

  getThongKeThanhTraTaiChinhNganSach(params) {
    this.setState({
      tableLoading: true
    });

    BaoCaoThanhTra.actions.getThongKeThanhTraTaiChinhNganSach.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getThongKePhatHienThamNhungQuaThanhTra(params) {
    this.setState({
      tableLoading: true
    });

    ThongKeBaoCao.actions.getThongKePhatHienThamNhungQuaThanhTra.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false
        });
      }
    });
  }

  getThongKeKetQuaThanhTraLai(params) {
    this.setState({
      tableLoading: true
    });

    ThongKeBaoCao.actions.getThongKeKetQuaThanhTraLai.request(null, params).then(res => {
      if (res.data && this.refs.thongKeBaoCao) {
        this.setState({
          data: res.data.maSos,
          dataSum: res.data.tongCongs,
          pageData: res.data.page,
          tableLoading: false,
          search: false
        });
      }
    });
  }


  onChange(name, e) {
    if (name == 'DonVi') {
      this.setState({
        dataSelected: e
      });
    } else if (name == 'statisticType') {
      this.setState({
        [name]: e.target.value,
        startDate: '',
        endDate: '',
        year: '',
        month: '',
        quarter: ''
      })
    } else if (name == 'donViCon') {
      this.setState({
        donViCon: !this.state.donViCon
      })
    } else {
      this.setState({
        [name]: e.target.value
      })
    }

    if (name == 'hinhThucThongKe' || name == 'statisticType') {

    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  hanldeSearch() {
    if (this.validateSubmitForm()) {
      this.setState({
        search: true
      })

      let dataSearch = {}

      if (this.state.statisticType == 'QUARTER') {
        dataSearch = {
          statisticType: this.state.statisticType,
          quarter: this.state.quarter,
          year: this.state.year
        }
      } else if (this.state.statisticType == 'SAU_THANG_CUOI_NAM' || this.state.statisticType == 'FIRST_SIX_MONTH' || this.state.statisticType == 'FIRST_NINE_MONTH' || this.state.statisticType == 'YEAR') {
        dataSearch = {
          statisticType: this.state.statisticType,
          year: this.state.year
        }
      } else if (this.state.statisticType == 'MONTH') {
        dataSearch = {
          statisticType: this.state.statisticType,
          year: this.state.year,
          month: this.state.month
        }
      } else if (this.state.statisticType == 'OPTION') {
        dataSearch = {
          statisticType: this.state.statisticType,
          startDate: this.state.startDate,
          endDate: this.state.endDate
        }
      }

      if (this.state.hinhThucThongKe) {
        dataSearch.hinhThucThongKe = this.state.hinhThucThongKe
      }

      if (this.state.nguonDon) {
        dataSearch.nguonDon = this.state.nguonDon;
      }

      if (this.state.hinhThucThongKe == 'CAP_DON_VI') {
        dataSearch.dsDonViId = '';
        dataSearch.capDonViId = this.state.capCoQuanThongKe
      } else {
        let self = this;
        let dsDonViId = '';
        if (this.state.dataSelected.length > 0) {
          this.state.dataSelected.map((item, index) => {
            if (index == 0) {
              dsDonViId = dsDonViId + self.state.dataSelected[index].value;
            }
            if (index > 0) {
              dsDonViId = dsDonViId + ',' + self.state.dataSelected[index].value;
            }
          });
        }

        dataSearch.dsDonViId = dsDonViId;
        dataSearch.capDonViId = '';
      }

      this.setState({
        dataValueListFilter: dataSearch,
        init: false
      }, () => {
        this.getListData(dataSearch);
      })
    }
  }

  downloadExcelReport({ name, apiUrl }) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const qs = {
      ...this.state.dataValueListFilter,
      hinhThucThongKe: this.state.dataValueListFilter.hinhThucThongKe || 'DON_VI',
      dsDonViId: this.state.dataValueListFilter.dsDonViId || String(userInfo.donViId),
      ...(this.state.startDate ? { startDate: moment(this.state.startDate).format('YYYY-MM-DD') } : {}),
      ...(this.state.endDate ? { endDate: moment(this.state.endDate).format('YYYY-MM-DD') } : {}),
    }

    const qsFunction = (input) => {
      return Object.entries(input)
        .filter(([key, value]) => value)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    }

    const URL = `${String(API_URL)}/${apiUrl}?${qsFunction(qs)}`;
    downloadExcel(URL, name, true);
  }

  handleExport() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    if (this.props.type == 'THANH_TRA_HANH_CHINH') {
      this.downloadExcelReport({ name: 'bao-cao-thanh-tra-hanh-chinh', apiUrl: 'thong-ke-bao-cao/01-TT' })
    } else if (this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH') {
      this.downloadExcelReport({ name: 'bao-cao-thuc-hien-ket-luan-thanh-tra-hanh-chinh', apiUrl: 'thong-ke-bao-cao/02-TT' })
    } else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
      this.downloadExcelReport({ name: 'bao-cao-thanh-tra-xay-dung-co-ban', apiUrl: 'thong-ke-bao-cao/03-TT' })
    } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
      this.downloadExcelReport({ name: 'bao-cao-thanh-tra-tai-chinh-ngan-sach', apiUrl: 'thong-ke-bao-cao/04-TT' })
    } else if (this.props.type == 'THANH_TRA_DAT_DAI') {
      this.downloadExcelReport({ name: 'bao-cao-thanh-tra-dat-dai', apiUrl: 'thong-ke-bao-cao/05-TT' })
    } else if (this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH') {
      this.downloadExcelReport({ name: 'bao-cao-thanh-tra-kiem-tra-chuyen-nganh', apiUrl: 'thong-ke-bao-cao/06-TT' })
    } else if (this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH') {
      this.downloadExcelReport({ name: 'bao-cao-xu-phat-kiem-tra-chuyen-nganh', apiUrl: 'thong-ke-bao-cao/07-TT' })
    } else if (this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP') {
      this.downloadExcelReport({ name: 'bao-cao-kiem-tra-chi-tiet-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/01-KQTKT' })
    } else if (this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP') {
      this.downloadExcelReport({ name: 'bao-cao-kiem-tra-theo-ke-hoach-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/02-KQTKT' })
    } else if (this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP') {
      this.downloadExcelReport({ name: 'bao-cao-kiem-tra-dot-xuat-doanh-nghiep', apiUrl: 'thong-ke-bao-cao/03-KQTKT' })
    } else if (this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA') {
      this.downloadExcelReport({ name: 'bao-cao-tong-hop-ket-qua-thanh-tra', apiUrl: 'thong-ke-bao-cao/04-KQTKT' })
    } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
      this.downloadExcelReport({ name: 'bao-cao-tong-hop-tham-nhung', apiUrl: 'thong-ke-bao-cao/BCTN' })
    }


    else if (this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN') {
      let URL = String(API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDauTuXayDungCoBan/xuatExcel?statisticType=" + this.state.statisticType
        + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '')
        + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '')
        + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '')
        + "&startDate=" + (this.state.dataValueListFilter.startDate ? moment(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '')
        + "&endDate=" + (this.state.dataValueListFilter.endDate ? moment(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '')
        + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI')
        + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId))
        + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

      downloadFile(URL);
    } else if (this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH') {
      let URL = String(API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraTheoTaiChinhNganSach/xuatExcel?statisticType=" + this.state.statisticType
        + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '')
        + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '')
        + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '')
        + "&startDate=" + (this.state.dataValueListFilter.startDate ? moment(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '')
        + "&endDate=" + (this.state.dataValueListFilter.endDate ? moment(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '')
        + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI')
        + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId))
        + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

      downloadFile(URL);
    } else if (this.props.type == 'THANH_TRA_THAM_NHUNG') {
      let URL = String(API_URL) + "/thongKeBaoCaos/tongHopKetQuaPhatHienThamNhungQuaThanhTra/xuatExcel?statisticType=" + this.state.statisticType
        + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '')
        + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '')
        + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '')
        + "&startDate=" + (this.state.dataValueListFilter.startDate ? moment(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '')
        + "&endDate=" + (this.state.dataValueListFilter.endDate ? moment(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '')
        + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI')
        + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId))
        + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

      downloadFile(URL);
    } else if (this.props.type == 'THANH_TRA_LAI') {
      let URL = String(API_URL) + "/thongKeBaoCaos/tongHopKetQuaThanhTraLai/xuatExcel?statisticType=" + this.state.statisticType
        + "&quarter=" + (this.state.dataValueListFilter.quarter ? this.state.dataValueListFilter.quarter : '')
        + "&year=" + (this.state.dataValueListFilter.year ? this.state.dataValueListFilter.year : '')
        + "&month=" + (this.state.dataValueListFilter.month ? this.state.dataValueListFilter.month : '')
        + "&startDate=" + (this.state.dataValueListFilter.startDate ? moment(this.state.dataValueListFilter.startDate).add(7, 'hours').toISOString() : '')
        + "&endDate=" + (this.state.dataValueListFilter.endDate ? moment(this.state.dataValueListFilter.endDate).add(7, 'hours').toISOString() : '')
        + "&hinhThucThongKe=" + (this.state.dataValueListFilter.hinhThucThongKe ? this.state.dataValueListFilter.hinhThucThongKe : 'DON_VI')
        + "&dsDonViId=" + (this.state.dataValueListFilter.dsDonViId ? this.state.dataValueListFilter.dsDonViId : String(userInfo.donViId))
        + "&capDonViId=" + (this.state.dataValueListFilter.capDonViId ? this.state.dataValueListFilter.capDonViId : '');

      downloadFile(URL);
    }
  }

  getListDV() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    DuLieuHeThong.actions.getDonViThongKe.request().then(res => {
      if (res.data._embedded) {
        let dataDonVi = [...res.data._embedded.coQuanQuanLies]
        let DonVi = dataDonVi.filter(state => {
          return state.coQuanQuanLyId == userInfo.donViId
        })
        this.setState({
          dataSelected: [
            { value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : '' }
          ],
          dataOptions: res.data._embedded.coQuanQuanLies
        })
      }
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  render() {
    const isResultReport = this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP' || this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP' || this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP' || this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA'

    return (
      <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
        <div className="top-content">
          <div className="left-content">
            <ShowIf condition={this.props.type == 'THANH_TRA_HANH_CHINH'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[01-TT] Tổng hợp kết quả thanh tra hành chính</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[02-TT] Tổng hợp kết quả thực hiện kết luận thanh tra hành chính</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[03-TT] Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đầu tư xây dựng cơ bản</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[04-TT] Tổng hợp kết quả thanh tra trong lĩnh vực tài chính ngân sách</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_DAT_DAI'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[05-TT] Tổng hợp kết quả thanh tra trong lĩnh vực đất đai</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[06-TT] Tổng hợp kết quả thanh tra, kiểm tra chuyên ngành</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH'}>
              <p className="title-18"><i className="tt tt-thongke"></i>[07-TT] Tổng hợp kết quả thực hiện kết luận, quyết định xử phạt qua thanh tra, kiểm tra chuyên ngành</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP'}>
              <p className="title-18"><i className='tt tt-thanh-tra'></i>Kết quả thanh tra, kiểm tra chi tiết doanh nghiệp,  cơ sở sản xuất kinh doanh</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP'}>
              <p className="title-18"><i className='tt tt-thanh-tra'></i>Kết quả thanh tra, kiểm tra theo kế hoạch doanh nghiệp, cơ sở sản xuất kinh doanh</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP'}>
              <p className="title-18"><i className='tt tt-thanh-tra'></i>Kết quả thanh tra, kiểm tra đột xuất doanh nghiệp, cơ sở sản xuất kinh doanh</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA'}>
              <p className="title-18"><i className='tt tt-thanh-tra'></i>Tổng hợp kết quả thanh tra, kiểm tra doanh nghiệp, cơ sở sản xuất kinh doanh</p>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_THAM_NHUNG'}>
              <p className="title-18"><i className="tt tt-thongke"></i>Tổng hợp kết quả phát hiện, xử lý tham nhũng phát hiện qua công tác thanh tra, kiểm tra</p>
            </ShowIf>
          </div>
        </div>
        <div className="bottom-content thongke-content">
          <div className="row pl25 pr25 pt15 super-search">
            <div className='col-83 no-gutter'>
              <DropDownChonLoaiKyThongKe className='col-25' placeholder={null} onChange={this.onChange.bind(this, 'statisticType')} selectedValue={this.state.statisticType} />
              <ShowIf condition={this.state.statisticType == 'QUARTER'}>
                <DropDownChonLoaiNamThongKe className='col-25' onChange={this.onChange.bind(this, 'year')} selectedValue={this.state.year} require={true} bindValidator={this} channel="formTaoDon" />
                <DropDownChonLoaiQuyThongKe className='col-25' onChange={this.onChange.bind(this, 'quarter')} selectedValue={this.state.quarter} require={true} bindValidator={this} channel="formTaoDon" />
              </ShowIf>
              <ShowIf condition={this.state.statisticType == 'SAU_THANG_CUOI_NAM' || this.state.statisticType == 'FIRST_SIX_MONTH' || this.state.statisticType == 'FIRST_NINE_MONTH' || this.state.statisticType == 'YEAR'}>
                <DropDownChonLoaiNamThongKe className='col-25' onChange={this.onChange.bind(this, 'year')} selectedValue={this.state.year ? this.state.year : moment().format('YYYY')} require={true} bindValidator={this} channel="formTaoDon" />
              </ShowIf>
              <ShowIf condition={this.state.statisticType == 'MONTH'}>
                <DropDownChonLoaiNamThongKe className='col-25' onChange={this.onChange.bind(this, 'year')} selectedValue={this.state.year} require={true} bindValidator={this} channel="formTaoDon" />
                <DropDownChonLoaiThangThongKe className='col-25' onChange={this.onChange.bind(this, 'month')} selectedValue={this.state.month} require={true} bindValidator={this} channel="formTaoDon" />
              </ShowIf>
              <ShowIf condition={this.state.statisticType == 'OPTION'}>
                <DatePicker className='col-25' label='Từ ngày' endDate={this.state.endDate} onChange={this.handleChangeDate.bind(this, 'startDate')} value={this.state.startDate} require={true} bindValidator={this} channel="formTaoDon" />
                <DatePicker className='col-25' label='Đến ngày' startDate={this.state.startDate} onChange={this.handleChangeDate.bind(this, 'endDate')} value={this.state.endDate} require={true} bindValidator={this} channel="formTaoDon" />
              </ShowIf>
              <ShowIf condition={!isResultReport}>
                <DropDownMulipleUse className='col-25' placeholder={null} label='Hình thức thống kê' onChange={this.onChange.bind(this, 'hinhThucThongKe')} selectedValue={this.state.hinhThucThongKe} data={this.state.dataHinhThucThongKe} keyName='giaTri' valueName='ten' />
              </ShowIf>
              <ShowIf condition={isResultReport}>
                <DropDownChonDonViThongKe className='col-25' placeholder={null} label='Đơn vị' onChange={this.onChange.bind(this, 'dsDonViIdKQ')} selectedValue={this.state.dsDonViIdKQ} isAll={true} disabled={!this.state.isThanhTraTinh} />
              </ShowIf>
            </div>
            <div className='col-16 btn-thongke clear-right'>
              <Button className={this.state.tableLoading ? (this.state.search ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable') : 'btn-green tt-search'} text="Xem kết quả" onClick={this.hanldeSearch.bind(this)} />
            </div>
            <ShowIf condition={this.state.hinhThucThongKe === 'DON_VI' && !isResultReport}>
              <div className='col-83 no-gutter clear-left'>
                <DropDownTreeMultipleSelect className='col-min-25 col-max-83' label="Đơn vị" dataOptions={this.state.dataOptions} dataSelected={this.state.dataSelected} onChange={this.onChange.bind(this, 'DonVi')} selectAllChildren={this.state.donViCon} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' />
                <label className="col-16 pt-control pt-checkbox checkbox-thong-ke">
                  <input type="checkbox" checked={this.state.donViCon} value={this.state.donViCon} onChange={this.onChange.bind(this, 'donViCon')} />
                  <span className="pt-control-indicator"></span>
                  <span className='val-checkbox'>Chọn đơn vị con</span>
                </label>
              </div>
            </ShowIf>
            <ShowIf condition={this.state.hinhThucThongKe == 'CAP_DON_VI'}>
              <div className='col-83 no-gutter'>
                <DropDownMulipleUse className='col-25' label='Cấp đơn vị báo cáo' onChange={this.onChange.bind(this, 'capCoQuanThongKe')} selectedValue={this.state.capCoQuanThongKe} data={this.state.dataCapCoQuanThongKe} keyName='capCoQuanQuanLyId' valueName='ten' />
              </div>
            </ShowIf>
          </div>
          <div className="col-100 no-gutter pt5">
            <span className="line-border"></span>
          </div>
          <div className="wrap-table clear-left">
            <ShowIf condition={this.props.type == 'THANH_TRA_HANH_CHINH'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThanhTraHanhChinh}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={20}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeThanhTraHanhChinh />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThucHienKetLuanThanhTraHanhchinh}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={24}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemKetQuaThucHienKetLuanThanhTraHanhChinh />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_XAY_DUNG_CO_BAN'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThanhTraXayDungCoBan}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={20}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeThanhTraXayDungCoBan />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_TAI_CHINH_NGAN_SACH'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThanhTraTaiChinhNganSach}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={20}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeThanhTraXayTaiChinhNganSach />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_DAT_DAI'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThanhTraDatDai}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={20}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeThanhTraDatDai />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_KIEM_TRA_CHUYEN_NGANH'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={29}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemthongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'XU_PHAT_KIEM_TRA_CHUYEN_NGANH'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoQuyetDinhXuPhatKiemTraChuyenNganh}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={16}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeQuyetDinhXuPhatThanhTraKiemTraChuyenNganh />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'THANH_TRA_THAM_NHUNG'}>
              <DataTable
                isReport={true}
                touchMove={true}
                header={header.thongKeBaoCaoThanhTraThamNhung}
                dataSum={this.state.dataSum}
                handleExport={this.handleExport.bind(this)}
                hidePagination={true}
                numberColumnHeader={26}
                ThongKeBaoCao={true}
                dataList={this.state.data}
                exporttext="Xuất báo cáo"
                pageData={this.state.pageData}
                parent={this}
                search={this.state.search}
                tableLoading={this.state.tableLoading}>
                <ListItemThongKeThanhTraThamNhung />
              </DataTable>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_CHI_TIET_DOANH_NGHIEP'}>
              <DataTableKetQua
                touchMove={true}
                header={header.ketQuaKiemTraChiTietDoanhNghiep}
                tableLoading={this.state.tableLoading}
                handleExport={this.handleExport.bind(this)}
                exportText="Xuất báo cáo"
              >
                <ListItemKetQuaKiemTraChiTiet dataList={this.state.data} totalCol={14} />
              </DataTableKetQua>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_THEO_KE_HOACH_DOANH_NGHIEP'}>
              <DataTableKetQua
                touchMove={true}
                header={header.ketQuaKiemTraTheoKeHoachDoanhNghiep}
                numberColumnHeader={27}
                tableLoading={this.state.tableLoading}
                handleExport={this.handleExport.bind(this)}
                exportText="Xuất báo cáo"
              >
                <ListItemKetQuaKiemTraTheoKeHoach dataList={this.state.data} totalCol={27} />
              </DataTableKetQua>
            </ShowIf>
            <ShowIf condition={this.props.type == 'KIEM_TRA_DOT_XUAT_DOANH_NGHIEP'}>
              <DataTableKetQua
                touchMove={true}
                header={header.ketQuaKiemTraDotXuatDoanhNghiep}
                numberColumnHeader={19}
                tableLoading={this.state.tableLoading}
                handleExport={this.handleExport.bind(this)}
                exportText="Xuất báo cáo"
              >
                <ListItemKetQuaKiemTraDotXuat dataList={this.state.data} totalCol={19} />
              </DataTableKetQua>
            </ShowIf>
            <ShowIf condition={this.props.type == 'TONG_HOP_KET_QUA_THANH_TRA'}>
              <DataTableKetQua
                touchMove={true}
                header={header.tongHopKetQuaThanhTra}
                numberColumnHeader={29}
                tableLoading={this.state.tableLoading}
                handleExport={this.handleExport.bind(this)}
                exportText="Xuất báo cáo"
              >
                <ListItemKetQuaTongHopKetQuaThanhTra dataList={this.state.data} totalCol={29} />
              </DataTableKetQua>
            </ShowIf>
          </div>
        </div>
      </div>
    );
  }
}

TongHopKetQua.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'TIEP_CONG_DAN'
}

export default connect()(TongHopKetQua);



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/TongHopKetQua.jsx